import Info from './Info.vue'


Info.install = function (Vue) {
    const InfoConstructor = Vue.extend(Info)

    const instance = new InfoConstructor()

    instance.$mount(document.createElement("div"))

    document.body.appendChild(instance.$el)

    Vue.prototype.$info = (options = {}) => {
        instance.gateway = options.gateway
        instance.scene = options.scene
        instance.visible = true
    }

    // Vue原型添加隐藏方法
    Vue.prototype.$hide_info = function () {
        instance.visible = false
    }
}


export default Info



// WEBPACK FOOTER //
// ./src/components/info/index.js